import { useEffect } from "react";

export default function useOutsideClick({
  refs,
  handler,
  enabled = true,
}) {
  useEffect(() => {
    if (!enabled) return;

    const listener = (event) => {
      // check if click is inside any ref
      const isInside = refs.some(
        (ref) => ref.current && ref.current.contains(event.target)
      );

      if (!isInside) {
        handler();
      }
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [refs, handler, enabled]);
}